import { MatcherFactory } from "../../models/matchers/factory/MatcherFactory";
import { Matcher } from "../../models/matchers/Matcher";
import { MatcherEditorChildProps } from "../matcherEditing/MatcherEditor";
import { AdvancedTooltip } from "../tooltips/AdvancedTooltip";
import { Label } from "./Label";
import { MatcherTypeLabel } from "./MatcherTypeLabel";

export { MatcherLabel };

type Props = MatcherEditorChildProps<Matcher> & { label: string };
const MatcherLabel = (props: Props) => (
  <AdvancedTooltip tooltipText={props.labelTooltip}>
    {(tProps) => (
      <>
        {props.changedMatcherType && (
          <MatcherTypeLabel
            onClick={props.onClickLabel}
            color={props.labelColor}
            backgroundColor={props.labelBgColor}
            {...tProps}
            filter={props.filter}
            onMatcherChange={(type) =>
              props.changedMatcherType!(
                MatcherFactory.changeMatcher(
                  props.matcher,
                  type,
                  props.defaultMatcherThreshold,
                ),
              )
            }
            discriminator={props.matcher.getDiscriminator()}
          >
            {props.label}
          </MatcherTypeLabel>
        )}
        {!props.changedMatcherType && (
          <Label
            onClick={props.onClickLabel}
            color={props.labelColor}
            backgroundColor={props.labelBgColor}
            {...tProps}
          >
            {props.label}
          </Label>
        )}
      </>
    )}
  </AdvancedTooltip>
);
